import React from 'react';
import { graphql } from 'gatsby';

import { Box, Container, Hidden, Stack, Typography } from '@mui/material';
import ImageFluid from '../../legacy/components/base/ImageFluid';
import { getKey } from '../../legacy/helpers';
import { useTranslation } from 'react-i18next';
import { AppStoreButton } from '../Footer/styles';
import GooglePlayIcon from '../Icons/GooglePlayIcon';
import TypographyLink from '../TypographyLink';
import AppStoreIcon from '../Icons/AppStoreIcon';

// ********************************************************************************
export const appBannerMapping = (props: any, locale: string) => {
  let suffix = '_en';
  if (locale === 'es') {
    suffix = '_es';
  }
  console.log(props);
  return {
    image: getKey(props, `image${suffix}.childImageSharp.fluid`),
  };
};

type Props = { image: any };
export const AppBanner = (props: Props) => {
  const { t } = useTranslation();
  const steps = [t('appBanner.step_1'), t('appBanner.step_2'), t('appBanner.step_3'), t('appBanner.step_4')];

  // == Render ====================================================================
  return (
    <Box component="section" bgcolor="white">
      <Container maxWidth="lg" sx={{ display: 'flex', py: '3em', px: '1em', gap: 6, justifyContent: 'center' }}>
        <Hidden mdDown>
          <Box component="figure" sx={{ flex: 1 }} maxHeight="680px" maxWidth="329px">
            <ImageFluid fluid={props.image} />
          </Box>
        </Hidden>
        <Stack spacing={2} sx={{ flex: 1 }} px={4} maxWidth="700px">
          <Typography variant="h2" color="#3F2B56" fontFamily="Gotham-Medium" fontSize="32px" align="left">
            {t('appBanner.title')}
          </Typography>
          <Typography
            variant="body1"
            color="#3C3C3B"
            fontSize="16px"
            lineHeight="19.2px"
            fontFamily="Gotham-Book"
            textAlign="left"
          >
            {t('appBanner.description')}
          </Typography>

          <Stack spacing={3} py={3}> 
            {steps.map((step, index) => (
              <Box display="flex" key={index} alignItems="center" fontFamily="Gotham-Medium" gap={2}>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  width="40px"
                  height="40px"
                  minWidth="40px"
                  minHeight="40px"
                  bgcolor="#EF60A3"
                  borderRadius="50%"
                >
                  <Typography color="white" fontSize="16px">
                    {index + 1}
                  </Typography>
                </Box>
                <Typography
                  key={index}
                  variant="body1"
                  color="#3C3C3B"
                  fontSize="18px"
                  lineHeight="19.2px"
                  fontFamily="Gotham-Medium"
                  textAlign="left"
                >
                  {step}
                </Typography>
              </Box>
            ))}
          </Stack>

          <Stack spacing={2} pt={3} bgcolor="#F3F2F5" py={2} px={3}>
            <Typography variant="body1" color="#262423" fontSize="22px" fontFamily="Gotham-Bold" textAlign="left">
              {t('appBanner.download')}
            </Typography>
            <Stack direction="row" gap="16px" flexWrap="wrap">
              <Box bgcolor="#3F2B56" borderRadius="8px" minWidth="150px">
                <AppStoreButton fullWidth>
                  <GooglePlayIcon />
                  <TypographyLink
                    href="https://play.google.com/store/apps/details?id=com.crossborderxpress.app&hl=es_419&gl=US"
                    color="white"
                    variant="body2"
                    sx={{ fontSize: { xs: '12px', md: '14px' } }}
                  >
                    {t('footer.available_in')}
                    <br />
                    <strong>{t('footer.google_play')}</strong>
                  </TypographyLink>
                </AppStoreButton>
              </Box>
              <Box bgcolor="#3F2B56" borderRadius="8px" minWidth="150px">
                <AppStoreButton fullWidth>
                  <AppStoreIcon />
                  <TypographyLink
                    href="https://apps.apple.com/us/app/cross-border-xpress/id1528607079"
                    color="white"
                    variant="body2"
                    sx={{ fontSize: { xs: '12px', md: '14px' } }}
                  >
                    {t('footer.available_in')}
                    <br />
                    <strong>{t('footer.app_store')}</strong>
                  </TypographyLink>
                </AppStoreButton>
              </Box>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

/**
 * GraphQL Query
 */
export const query = graphql`
  fragment AppBanners on StrapiWidgetrels {
    appBanner {
      key: id
      image_es {
        childImageSharp {
          fluid(maxWidth: 800, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      image_en {
        childImageSharp {
          fluid(maxWidth: 800, quality: 80) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
      widgetPosition
    }
  }
`;
